const assetTypeLabel = {
  PrivateLLC: 'Private LLC',
  OtherCash: 'Other Cash',
  MetalsAndCurrency: 'Metals And Currency',
  PublicLLC: 'Public LLC',
  MutualFunds: 'Mutual Funds',
  RealEstate: 'Real Estate',
  TemporaryIRALoan: 'Temporary IRA Loan',
  MortgageDebt: 'Mortgage Debt',
  Trusts: 'Trusts',
  Stock: 'Stock',
  Cash: 'Cash',
  Bonds: 'Bonds',
  Extraordinary: 'Extraordinary',
};

export const getAssetTypeLabel = (
  assetType: string,
  assetValueType: string
) => {
  //Showing 'Note' for Cash assets with a value type of Note
  if (assetType === 'Cash' && assetValueType === 'Note') {
    return assetValueType;
  }

  const label = assetTypeLabel[assetType];
  if (label) {
    return label;
  }

  return assetType;
};
